//LoanApplicationForm
import React, { useState,useEffect } from "react";
// import Input from '../../Components/Atoms/Input/Input'
import {
  
  FormDropdown,
  FormField
} from "../../Components/Molecules/FormField/FormField";

import ErrorLabel from "../../Components/Atoms/ErrorLabel/ErrorLabel";
import {PrimaryButton,} from "../../Components/Atoms/Button/Button";

import HBar from "../../Components/Bars/Bars";

import {getLoanApplicationDetailsApi,get_user_details, get_master_data,updateLoanApplication} from "../../Enums/api_constunts"
import { postMethod } from "../../Helpers/services";
import _ from "lodash"

export const ObligationsChart = ({ setObligation_list,formik,loanFormDetails }) => {
  const [obligationFields, setObligationFields] = useState([
    {
      obligationType: "",
      loanAmount: "",
      totaltenure: "",
      roi: "",
      bankName: "",
      presentOS: "",
      balanceTerm: "",
      emiAmount: "",
      totalObligationPerMonth: "", // New field added
    },
  ]);
  useEffect(() => {
    if (_.has(loanFormDetails, "all_obligations")) {
      
      try {
        let obligations = loanFormDetails.all_obligations;
        obligations = JSON.parse(loanFormDetails.all_obligations);
        let allitems = [];
        if (Array.isArray(obligations)) {
          obligations.forEach((item,index)=>{
            allitems.push(item);
            /*
            obligationType: "",
          loanAmount: "",
          totaltenure: "",
          roi: "",
          bankName: "",
          presentOS: "",
          balanceTerm: "",
          emiAmount: "",
          totalObligationPerMonth: "", // Initialize new field
            */
            formik.setFieldValue(`obligationFields[${index}].obligationType`, item["obligationType"]);
            formik.setFieldValue(`obligationFields[${index}].loanAmount`, item["loanAmount"]);
            formik.setFieldValue(`obligationFields[${index}].totaltenure`, item["totaltenure"]);
            formik.setFieldValue(`obligationFields[${index}].roi`, item["roi"]);
            formik.setFieldValue(`obligationFields[${index}].bankName`, item["bankName"]);
            formik.setFieldValue(`obligationFields[${index}].presentOS`, item["presentOS"]);
            formik.setFieldValue(`obligationFields[${index}].balanceTerm`, item["balanceTerm"]);
            formik.setFieldValue(`obligationFields[${index}].emiAmount`, item["emiAmount"]);
            formik.setFieldValue(`obligationFields[${index}].totalObligationPerMonth`, item["totalObligationPerMonth"]);
          });
        }
        if(allitems.length>0){

       
        setObligationFields(allitems);
        setObligation_list(allitems)
      }

      } catch (error) {
        console.error('Error processing all_obligations:', error);
      }
    }
  }, [loanFormDetails]);

  const handleAddIncomeField = () => {
    const updatedFields = [
        ...obligationFields,
        {
          obligationType: "",
          loanAmount: "",
          totaltenure: "",
          roi: "",
          bankName: "",
          presentOS: "",
          balanceTerm: "",
          emiAmount: "",
          totalObligationPerMonth: "", // Initialize new field
        },
      ]
    setObligationFields(updatedFields);
    
  };

  const handleRemoveIncomeField = (index) => {
    const updatedFields = obligationFields.filter((_, i) => i !== index);
    setObligationFields(updatedFields);
    
  };

  const handleFieldChange = (index, field, value) => {
    
    const updatedFields = obligationFields.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    setObligationFields(updatedFields);
    
    formik.setFieldValue(`obligationFields[${index}].${field}`, value);
    
  };
  useEffect(()=>{
    
    setObligation_list([...obligationFields])
  },[obligationFields])

  const [serviceTypes, setServiceTypes] = useState([])
  const getMasterData = ()=>{
    let postData = {"categories":["md_lead_sources","md_profession_types","md_profession_sub_types","md_service_types","md_income_types","md_obligation_types"]};
    //values["tenant_id"] = _.get(selectedTenant,"id");
     postMethod(get_master_data,postData).then((res)=>{
        //setLeadSourceList( _.get(res,"result.md_lead_sources",[]).map((item)=>{ item["label"] =  item["name"];return item}))
        //setProfessionList( _.get(res,"result.md_profession_types",[]).map((item)=>{ item["label"] =  item["name"];return item}))
        setServiceTypes( _.get(res,"result.md_service_types",[]).map((item)=>{ item["label"] =  item["name"];return item}))
        //setincomTypeList( _.get(res,"result.md_income_types",[]).map((item)=>{ item["label"] =  item["name"];return item}))
        //setProfessionSubList( _.get(res,"result.md_profession_sub_types",[]).map((item)=>{ item["label"] =  item["name"];return item}))
      })
  }
  useEffect(()=>{
    getMasterData()
  },[])
  const otherIncomeOptions = [
    {
      id: true,
      label: "Yes",
    },
    {
      id: false,
      label: "No",
    },
  ];

 
  return (
    <div style={{marginTop:obligationFields.length>0 && "12px"}}>
<HBar label="Fill the obligation form"/>
<div className="row">
        <div className="col-md-4 mb-2">
          <FormDropdown
            label="Obligations"
            id="Obligations"
            name="Obligations"
            options={otherIncomeOptions}
            onChange={(selected) => {
              formik.setFieldValue("Obligations", selected?.id === true ? "Yes" : "No");
              if(selected?.id === false || selected?.label == "No") { // Check for boolean false instead of string "No"
                formik.setFieldValue("obligations_per_month", 0)
              }
              setTimeout(()=>{
                //calculateSpendingPercentage()
              },100)
              
            }}
            value={formik.values.Obligations}
            error={formik.touched.Obligations && formik.errors.Obligations}
            onBlur={formik.handleBlur}
          />
          {formik.touched.Obligations && (
            <ErrorLabel
              name="Obligations"
              formik={formik}
              message={formik.errors.Obligations}
            />
          )}
        </div>
        
        {formik.values.Obligations === "Yes" && (
          <div className="col-md-4 mb-2">
            <FormField
              label="Total Obligations per Month"
              id="obligations_per_month"
              name="obligations_per_month"
              onChange={(e) => {
                
                //formik.setFieldValue("obligations_per_month", selected?.label);
              }}
              value={formik.values.obligations_per_month}
              error={formik.touched.obligations_per_month && formik.errors.obligations_per_month}
              onBlur={formik.handleBlur}
              disableAlphebets={true}
              disableSymbols={true}
              readOnly
              focus={formik.values.obligations_per_month ? true : false}
            />
            {formik.touched.obligations_per_month && (
              <ErrorLabel
                name="obligations_per_month"
                formik={formik}
                message={formik.errors.obligations_per_month}
              />
            )}
          </div>
        )}
      </div>
      
      {formik.values.Obligations === "Yes" && <>
      
      
      
      
      {obligationFields.map((field, index) => (
        <div key={index} className="obligation-section">
          <div className="row">
            {/* Row 1 */}
           
            <div className="col-md-4 mb-2">
              <FormDropdown
                id={`obligation_list-${index}`}
                name={`obligation_list[${index}].obligationType`}
                label="Obligation Type"
                options={serviceTypes.filter((item)=>item.id !=1)}
                onChange={(selected) => {
                  handleFieldChange(index, 'obligationType', selected?.label);
                  
                }}
                value={obligationFields?.[index]?.obligationType}
                error={
                  formik.touched.obligation_list?.[index]?.obligationType &&
                  formik.errors.obligation_list?.[index]?.obligationType
                }
                onBlur={formik.handleBlur}
              />
              {formik.touched.obligation_list?.[index]?.obligationType && (
                <ErrorLabel
                  name={`obligation_list[${index}].obligationType`}
                  formik={formik}
                  message={formik.errors.obligation_list?.[index]?.obligationType}
                />
              )}
            </div>
            <div className="col-md-4 mb-2">
              <FormField
                label={`Loan Amount`}
                id={`loanAmount-${index}`}
                name={`obligation_list[${index}].loanAmount`}
                type="text"
                value={field.loanAmount}
                onChange={(e) =>{
                  handleFieldChange(index, "loanAmount", e.target.value)
                 
                }
                }
                error={
                  formik.touched.obligation_list?.[index]?.loanAmount &&
                  formik.errors.obligation_list?.[index]?.loanAmount
                }
                onBlur={formik.handleBlur}
              />
              {formik.touched.obligation_list?.[index]?.loanAmount && (
                <ErrorLabel
                  name={`obligation_list[${index}].loanAmount`}
                  formik={formik}
                  message={formik.errors.obligation_list?.[index]?.loanAmount}
                />
              )}
            </div>
            <div className="col-md-4 mb-2">
              <FormField
                label="Total Tenure (In Months)"
                id={`totaltenure-${index}`}
                name={`obligation_list[${index}].totaltenure`}
                type="text"
                value={field.totaltenure}
                onChange={(e) =>{
                  handleFieldChange(index, "totaltenure", e.target.value)
                  
                }
                }
                error={
                  formik.touched.obligation_list?.[index]?.totaltenure &&
                  formik.errors.obligation_list?.[index]?.totaltenure
                }
                onBlur={formik.handleBlur}
              />
              {formik.touched.obligation_list?.[index]?.totaltenure && (
                <ErrorLabel
                  name={`obligation_list[${index}].totaltenure`}
                  formik={formik}
                  message={formik.errors.obligation_list?.[index]?.totaltenure}
                />
              )}
            </div>
          </div>

          {/* Row 2 */}
          <div className="row">
            <div className="col-md-4 mb-2">
              <FormField
                label="Rate of Interest"
                id={`roi-${index}`}
                name={`obligation_list[${index}].roi`}
                type="text"
                value={field.roi}
                onChange={(e) =>{
                  handleFieldChange(index, "roi", e.target.value)
                  
                }
                
                }
                error={
                  formik.touched.obligation_list?.[index]?.roi &&
                  formik.errors.obligation_list?.[index]?.roi
                }
                onBlur={formik.handleBlur}
              />
              {formik.touched.obligation_list?.[index]?.roi && (
                <ErrorLabel
                  name={`obligation_list[${index}].roi`}
                  formik={formik}
                  message={formik.errors.obligation_list?.[index]?.roi}
                />
              )}
            </div>
            <div className="col-md-4 mb-2">
              <FormField
                label="Bank Name"
                id={`bankName-${index}`}
                name={`obligation_list[${index}].bankName`}
                type="text"
                value={field.bankName}
                onChange={(e) =>{
                  handleFieldChange(index, "bankName", e.target.value)
                  
                }
                  
                }
                error={
                  formik.touched.obligation_list?.[index]?.bankName &&
                  formik.errors.obligation_list?.[index]?.bankName
                }
                onBlur={formik.handleBlur}
              />
              {formik.touched.obligation_list?.[index]?.bankName && (
                <ErrorLabel
                  name={`obligation_list[${index}].bankName`}
                  formik={formik}
                  message={formik.errors.obligation_list?.[index]?.bankName}
                />
              )}
            </div>
            <div className="col-md-4 mb-2">
              <FormField
                label="Present Outstanding"
                id={`presentOS-${index}`}
                name={`obligation_list[${index}].presentOS`}
                type="text"
                value={field.presentOS}
                onChange={(e) =>{
                  handleFieldChange(index, "presentOS", e.target.value)
                 
                }
                  
                }
                error={
                  formik.touched.obligation_list?.[index]?.presentOS &&
                  formik.errors.obligation_list?.[index]?.presentOS
                }
                onBlur={formik.handleBlur}
              />
              {formik.touched.obligation_list?.[index]?.presentOS && (
                <ErrorLabel
                  name={`obligation_list[${index}].presentOS`}
                  formik={formik}
                  message={formik.errors.obligation_list?.[index]?.presentOS}
                />
              )}
            </div>
          </div>

          {/* Row 3 */}
          <div className="row">
            <div className="col-md-4 mb-2">
              <FormField
                label="Balance Term (In Months)"
                id={`balanceTerm-${index}`}
                name={`obligation_list[${index}].balanceTerm`}
                type="text"
                value={field.balanceTerm}
                onChange={(e) =>{
                  handleFieldChange(index, "balanceTerm", e.target.value)
                  
                }
                }
                error={
                  formik.touched.obligation_list?.[index]?.balanceTerm &&
                  formik.errors.obligation_list?.[index]?.balanceTerm
                }
                onBlur={formik.handleBlur}
              />
              {formik.touched.obligation_list?.[index]?.balanceTerm && (
                <ErrorLabel
                  name={`obligation_list[${index}].balanceTerm`}
                  formik={formik}
                  message={formik.errors.obligation_list?.[index]?.balanceTerm}
                />
              )}
            </div>
            <div className="col-md-4 mb-2">
              <FormField
                label="EMI Amount"
                id={`emiAmount-${index}`}
                name={`obligation_list[${index}].emiAmount`}
                type="text"
                value={field.emiAmount}
                onChange={(e) =>{
                  handleFieldChange(index, "emiAmount", e.target.value)
                  
                }
                }
                error={
                  formik.touched.obligation_list?.[index]?.emiAmount &&
                  formik.errors.obligation_list?.[index]?.emiAmount
                }
                onBlur={formik.handleBlur}
              />
              {formik.touched.obligation_list?.[index]?.emiAmount && (
                <ErrorLabel
                  name={`obligation_list[${index}].emiAmount`}
                  formik={formik}
                  message={formik.errors.obligation_list?.[index]?.emiAmount}
                />
              )}
            </div>
            
          </div>

          {/* Add/Remove Buttons */}
          <div className="d-flex justify-content-center align-items-center mt-1 mb-1">
            {obligationFields.length > 1 && (
              <button
                type="button"
                className="btn btn-danger me-2"
                onClick={() => handleRemoveIncomeField(index)}
              >
                Remove
              </button>
            )}
            {index === obligationFields.length - 1 && (
              <PrimaryButton
                type="button"
                className="btn btn-primary mb-2"
                onClick={handleAddIncomeField}
              >
                Add Another Obligation
              </PrimaryButton>
            )}
          </div>
        </div>
      ))}
      </>}
    </div>
  );
};